import React from 'react';
import {mergeStyleSets, useTheme} from '@fluentui/react';
import {useMemo} from 'react';
import {getListClassNames} from 'styles';

export const useVkoApproverWorkbenchStyles = () => {
	const theme = useTheme();
	const listClassNames = getListClassNames(theme, false);
	const vkoClassNames = (theme: any) =>
		mergeStyleSets({
			mainHeaderContainer: {
				display: 'flex',
				justifyContent: 'space-between',
				background: theme.palette.white,
				margin: 10,
				borderRadius: 15,
			},
			rowSectionContainer: {
				background: theme.palette.black,
				color: theme.palette.white,
				paddingTop: 10,
				margin: 10,
				borderRadius: 15,
			},
			rowSectionContainerContent: {
				margin: 10,
				marginLeft: 20,
				fontWeight: 600,
				fontSize: 18,
				lineHeight: 16,
			},
			roundedDashboardActivityContainer: {
				background: theme.palette.white,
				margin: 10,
				marginTop: 0,
				paddingTop: 10,
				borderRadius: 15,
				paddingBottom: 10,
			},
			fixedActivityContainer: {
				background: theme.palette.white,
				margin: 10,
				paddingTop: 10,
				borderRadius: 15,
				height: 480,
			},
			cardContainer: {
				margin: 10,
				borderRadius: 15,
			},
			paddingTop: {
				paddingtTop: 10,
			},
			primaryCounter: {
				fontSize: 24,
				color: theme.palette.themePrimary,
				fontWeight: 600,
			},
		});
	const paddingAll = useMemo(() => {
		return {
			padding: 10,
		};
	}, []);

	const paddingTop = useMemo(() => {
		return {
			paddingTop: 10,
		};
	}, []);

	const widthSTD40 = {minWidth: 40, maxWidth: 60};
	const widthSTD60 = {minWidth: 60, maxWidth: 80};
	const widthSTD80 = {minWidth: 80, maxWidth: 100};
	const widthSTD100 = {minWidth: 100, maxWidth: 100};
	const widthSTD120 = {minWidth: 120, maxWidth: 120};
	const widthSTD180 = {minWidth: 180, maxWidth: 200};
	const width33 = {width: '33%'};

	return {
		classNames: vkoClassNames(theme),
		listClassNames,
		paddingAll,
		paddingTop,
		widthSTD40,
		widthSTD60,
		widthSTD80,
		widthSTD100,
		widthSTD120,
		widthSTD180,
		width33,
	};
};
